import React from 'react';
import { images, routes } from '../constants';
import { Card, Image } from '../components';

class AppCTA extends React.Component {

    static get styles() {
        return {
            CARD: 'CARD',
            MINI_SUBMIT: 'MINI_SUBMIT'
        }
    }

    renderCard() {
        return (
            <Card className={['component-app-cta', 'center', 'style-card', this.props.className].join(' ')}>
                <h3 className="card-title">Have You Tried Our iPhone App?</h3>
                <p>Scan and submit samples, track progress, and manage reports more conveniently than ever.</p>
                <a href={routes.APP_STORE} target="_blank"><Image src={images.APPLE_STORE} /></a>
            </Card>
        )
    }

    renderMiniSubmit() {
        return (
            <div className={['component-app-cta', 'center', 'style-mini-submit', this.props.className].join(' ')}>
                <div className="cta-content">
                    <h4 className="mini-cta">Submit samples with our app.</h4>
                    <a className="mini-link" href={routes.APP_STORE} target="_blank"><Image src={images.APPLE_STORE} /></a>
                    <div className="clearfix"></div>
                </div>
            </div>
        )
    }

    render () {
        switch (this.props.style) {
            case AppCTA.styles.CARD:
                return this.renderCard();
            case AppCTA.styles.MINI_SUBMIT:
                return this.renderMiniSubmit();
            default:
                return this.renderCard();

        }
    }
}

export default AppCTA;



// WEBPACK FOOTER //
// ./web-app/components/app-cta.jsx